import { useEffect, useState } from 'react';
import { Button, Tooltip, TooltipContent, TooltipTrigger, cn } from '@design-system';
import { Check, Loader2 } from 'lucide-react';

interface FilterDefaultsControlsProps {
  isSaving: boolean;
  isSuccess: boolean;
  onSave: () => void;
}

export function FilterDefaultsControls({
  isSaving,
  isSuccess,
  onSave,
}: FilterDefaultsControlsProps) {
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (isSuccess) {
      setShowSuccess(true);
      const timer = setTimeout(() => setShowSuccess(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [isSuccess]);

  return (
    <div className="border-border border-t pt-5">
      <Tooltip disableHoverableContent>
        <TooltipTrigger className="w-full">
          <Button
            variant="outline"
            className={cn('w-full gap-2 transition-colors', {
              'opacity-100! border-green-600/20 bg-green-600/5 text-green-800': showSuccess,
            })}
            onClick={onSave}
            disabled={isSaving || showSuccess}
          >
            {isSaving ? (
              <>
                <Loader2 className="size-4 animate-spin" />
                Saving...
              </>
            ) : showSuccess ? (
              <>
                <Check className="size-4" />
                Filters Saved
              </>
            ) : (
              'Save Filters'
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="max-w-64 text-center"
        >
          Save your current filters as defaults, they'll apply automatically for every client.
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
